export const recentMessages = [
  {
    id: 1,
    sender: "Sarah Mitchell",
    role: "HR Manager",
    avatar: "https://public.readdy.ai/ai/img_res/8fdf118163f8c185b3bed160ae9e22ad.jpg",
    preview: "We reviewed your application and would like to schedule...",
    time: "10:32 AM",
    unread: true,
  },
  {
    id: 2,
    sender: "Robert Chen",
    role: "CEO, TechVision",
    avatar: "https://readdy.ai/api/search-image?query=professional%20male%20CEO%20executive%20portrait%20confident%20clean%20background%20studio&width=60&height=60&seq=msg2&orientation=squarish",
    preview: "The team is excited to have you onboard. Please review...",
    time: "Yesterday",
    unread: true,
  },
  {
    id: 3,
    sender: "Amanda Torres",
    role: "Recruiter",
    avatar: "https://readdy.ai/api/search-image?query=professional%20female%20recruiter%20portrait%20smile%20clean%20background%20studio&width=60&height=60&seq=msg3&orientation=squarish",
    preview: "Following up on your interview from last week...",
    time: "Apr 8",
    unread: false,
  },
];

export const announcements = [
  {
    id: 1,
    title: "Platform Maintenance — Apr 15, 2026",
    date: "Apr 10, 2026",
    type: "warning",
    content: "Scheduled maintenance from 2:00 AM - 4:00 AM EST. Brief downtime expected.",
  },
  {
    id: 2,
    title: "New Feature: Video Interview Tool Now Live",
    date: "Apr 8, 2026",
    type: "info",
    content: "Employers can now conduct video interviews directly on the platform.",
  },
  {
    id: 3,
    title: "Crown Job Fair — April 20, 2026",
    date: "Apr 5, 2026",
    type: "success",
    content: "Join 200+ employers at our virtual job fair. Register now to secure your spot.",
  },
];

export const feedbackStats = {
  averageRating: 4.7,
  totalReviews: 12847,
  breakdown: [
    { stars: 5, percent: 68 },
    { stars: 4, percent: 20 },
    { stars: 3, percent: 8 },
    { stars: 2, percent: 3 },
    { stars: 1, percent: 1 },
  ],
};

export const communityPeople = [
  { id: 1, name: "Dr. Emily Chen", role: "Pediatrician", country: "🇺🇸", avatar: "https://readdy.ai/api/search-image?query=female%20doctor%20pediatrician%20professional%20portrait%20white%20coat%20warm%20smile%20clean%20studio%20background&width=80&height=80&seq=doc1&orientation=squarish", online: true, tag: "Doctor", color: "teal" },
  { id: 2, name: "Dr. James Okafor", role: "General Practitioner", country: "🇳🇬", avatar: "https://readdy.ai/api/search-image?query=male%20African%20doctor%20general%20practitioner%20professional%20portrait%20white%20coat%20confident%20clean%20studio%20background&width=80&height=80&seq=doc2&orientation=squarish", online: true, tag: "Doctor", color: "teal" },
  { id: 3, name: "Maria Santos", role: "Social Worker", country: "🇧🇷", avatar: "https://readdy.ai/api/search-image?query=female%20social%20worker%20professional%20portrait%20warm%20smile%20caring%20clean%20studio%20background&width=80&height=80&seq=sw1&orientation=squarish", online: false, tag: "Helper", color: "rose" },
  { id: 4, name: "Kevin Park", role: "Nutritionist", country: "🇰🇷", avatar: "https://readdy.ai/api/search-image?query=male%20nutritionist%20health%20professional%20portrait%20friendly%20smile%20clean%20studio%20background&width=80&height=80&seq=nut1&orientation=squarish", online: true, tag: "Expert", color: "amber" },
  { id: 5, name: "Dr. Priya Nair", role: "Psychologist", country: "🇮🇳", avatar: "https://readdy.ai/api/search-image?query=female%20Indian%20psychologist%20professional%20portrait%20calm%20warm%20smile%20clean%20studio%20background&width=80&height=80&seq=psy1&orientation=squarish", online: true, tag: "Doctor", color: "teal" },
  { id: 6, name: "Tom Harrington", role: "Volunteer Coordinator", country: "🇬🇧", avatar: "https://readdy.ai/api/search-image?query=male%20volunteer%20coordinator%20professional%20portrait%20friendly%20smile%20clean%20studio%20background&width=80&height=80&seq=vol1&orientation=squarish", online: false, tag: "Volunteer", color: "green" },
];

export const communityPosts = [
  {
    id: 1,
    user: "Dr. Emily Chen",
    avatar: "https://readdy.ai/api/search-image?query=female%20doctor%20pediatrician%20professional%20portrait%20white%20coat%20warm%20smile%20clean%20studio%20background&width=60&height=60&seq=doc1p&orientation=squarish",
    role: "Pediatrician",
    country: "🇺🇸",
    tag: "Doctor",
    tagColor: "teal",
    emotion: "caring",
    emotionIcon: "ri-heart-line",
    time: "2 hours ago",
    content: "Happy to offer FREE pediatric advice to any parent worried about their infant's health. Just reply here or send me a message. Every child deserves proper care — no matter where you are in the world.",
    helpType: "Free Medical Advice",
    likes: 87,
    replies: 23,
    helped: 15,
  },
  {
    id: 2,
    user: "Aisha Bello",
    avatar: "https://readdy.ai/api/search-image?query=young%20African%20woman%20portrait%20warm%20smile%20hopeful%20clean%20studio%20background&width=60&height=60&seq=ab1&orientation=squarish",
    role: "Single Mother",
    country: "🇳🇬",
    tag: "Need Help",
    tagColor: "rose",
    emotion: "hopeful",
    emotionIcon: "ri-emotion-line",
    time: "4 hours ago",
    content: "I have a 3-month-old baby and I am struggling to afford milk and warm clothes. If anyone can help or advise me on resources available, I would be so grateful. God bless you all.",
    helpType: "Needs Support",
    likes: 142,
    replies: 38,
    helped: 0,
  },
  {
    id: 3,
    user: "Dr. James Okafor",
    avatar: "https://readdy.ai/api/search-image?query=male%20African%20doctor%20general%20practitioner%20professional%20portrait%20white%20coat%20confident%20clean%20studio%20background&width=60&height=60&seq=doc2p&orientation=squarish",
    role: "General Practitioner",
    country: "🇳🇬",
    tag: "Doctor",
    tagColor: "teal",
    emotion: "supportive",
    emotionIcon: "ri-hand-heart-line",
    time: "6 hours ago",
    content: "Offering free general health consultations online. If you or your family need medical guidance and cannot afford a doctor visit, please reach out. Health is a human right.",
    helpType: "Free Consultation",
    likes: 64,
    replies: 17,
    helped: 22,
  },
  {
    id: 4,
    user: "Linda Zhao",
    avatar: "https://readdy.ai/api/search-image?query=Chinese%20woman%20professional%20portrait%20warm%20smile%20generous%20clean%20studio%20background&width=60&height=60&seq=lz1&orientation=squarish",
    role: "Business Owner",
    country: "🇨🇳",
    tag: "Donor",
    tagColor: "amber",
    emotion: "generous",
    emotionIcon: "ri-gift-line",
    time: "8 hours ago",
    content: "I just made a donation for infants in need. It feels amazing to know that somewhere a baby will have warm milk and clothes tonight. I encourage everyone who can afford it — please donate. Even $10 changes a life.",
    helpType: "Donated",
    likes: 203,
    replies: 45,
    helped: 0,
  },
  {
    id: 5,
    user: "Dr. Priya Nair",
    avatar: "https://readdy.ai/api/search-image?query=female%20Indian%20psychologist%20professional%20portrait%20calm%20warm%20smile%20clean%20studio%20background&width=60&height=60&seq=psy1p&orientation=squarish",
    role: "Psychologist",
    country: "🇮🇳",
    tag: "Doctor",
    tagColor: "teal",
    emotion: "empathetic",
    emotionIcon: "ri-mental-health-line",
    time: "Yesterday",
    content: "Mental health matters. If you are feeling overwhelmed, anxious, or just need someone to talk to — I am here. Free emotional support sessions available. You are not alone.",
    helpType: "Free Counseling",
    likes: 119,
    replies: 31,
    helped: 18,
  },
  {
    id: 6,
    user: "Carlos Rivera",
    avatar: "https://readdy.ai/api/search-image?query=Latino%20man%20professional%20portrait%20friendly%20smile%20clean%20studio%20background&width=60&height=60&seq=cr1&orientation=squarish",
    role: "Chef & Restaurant Owner",
    country: "🇲🇽",
    tag: "Helper",
    tagColor: "green",
    emotion: "joyful",
    emotionIcon: "ri-emotion-happy-line",
    time: "Yesterday",
    content: "Every Sunday our restaurant provides free meals for families in need. If you are in Los Angeles and struggling, come by. No questions asked. Food is love.",
    helpType: "Free Meals",
    likes: 178,
    replies: 52,
    helped: 34,
  },
];

export const emotionOptions = [
  { key: "happy", label: "Happy", icon: "ri-emotion-happy-line", color: "text-amber-500" },
  { key: "caring", label: "Caring", icon: "ri-heart-line", color: "text-rose-500" },
  { key: "hopeful", label: "Hopeful", icon: "ri-sun-line", color: "text-orange-400" },
  { key: "supportive", label: "Supportive", icon: "ri-hand-heart-line", color: "text-teal-500" },
  { key: "grateful", label: "Grateful", icon: "ri-sparkling-line", color: "text-amber-400" },
  { key: "sad", label: "Sad", icon: "ri-emotion-sad-line", color: "text-stone-400" },
  { key: "worried", label: "Worried", icon: "ri-emotion-unhappy-line", color: "text-stone-500" },
  { key: "generous", label: "Generous", icon: "ri-gift-line", color: "text-green-500" },
];
